import React, { useRef } from "react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./swiper-custom.css";
import workout from "../../assets/images/workout.jpg";
import workout1 from "../../assets/images/workout1.jpg";
import workout2 from "../../assets/images/workout2.jpg";
import workout3 from "../../assets/images/workout3.jpg";
import workout4 from "../../assets/images/workout4.jpg";
import videoCover from "../../assets/logos/svg/Garejelebi Logo variations-12-04.svg";
import videoCoverMobile from "../../assets/logos/svg/Garejelebi Logo variations-12-09.svg";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useMobile } from "../../hooks/use-mobile";
import PrimaryButton from "../../UI/PrimaryButton";

const SlidesContent = () => {
  const isMobile = useMobile();
  const { t } = useTranslation();
  const youtubeRef = useRef(null);

  const slidesData = [
    {
      type: "youtube",
      videoId: "CNvmWCEAr1o",
      coverImage: !isMobile ? videoCover : videoCoverMobile,
      description: t(
        "Discover Mamuka’s Expertise - Learn from the Best, Compete with the Best"
      ),
    },
    {
      type: "image",
      image: workout,
      title: t("crushYourLimits"),
      text: t("crushYourLimitsText"),
    },
    {
      type: "image",
      image: workout1,
      title: t("powerMeetsTechnic"),
      text: t("powerMeetsTechnicText"),
    },
    {
      type: "image",
      image: workout2,
      title: t("riseTop"),
      text: t("riseTopText"),
    },
    {
      type: "image",
      image: workout3,
      title: t("masterTheArt"),
      text: t("masterTheArtText"),
    },
    {
      type: "image",
      image: workout4,
      title: t("powerInProgress"),
      text: t("powerInProgressText"),
    },
  ];

  // Pause YouTube video when the slide changes
  const handleSlideChange = () => {
    if (youtubeRef.current) {
      youtubeRef.current.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    }
  };

  return (
    <Swiper
      modules={[Navigation, Pagination, Scrollbar, A11y]}
      spaceBetween={1}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      speed={1000}
      loop={true}
      className="relative"
      onSlideChange={handleSlideChange} // ✅ Trigger when slide changes
    >
      {slidesData.map((slide, index) => (
        <SwiperSlide key={index}>
          {slide.type === "youtube" ? (
            <div className="relative h-[600px] lg:h-[720px] w-full flex items-center bg-black justify-center">
              <iframe
                ref={youtubeRef}
                className="absolute inset-0 w-full h-[95%] z-50"
                src={`https://www.youtube.com/embed/${slide.videoId}?enablejsapi=1&autoplay=1&mute=1&rel=0&loop=1&playlist=${slide.videoId}`}
                title="YouTube Video"
                allow="autoplay; encrypted-media"
                allowFullScreen
                style={{ pointerEvents: "auto", zIndex: 50 }}
              />
            </div>
          ) : (
            <div
              className="h-[600px] lg:h-[720px] w-full bg-cover bg-center text-white flex flex-col justify-center items-center gap-6 p-8"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${slide.image})`,
              }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-center">
                {slide.title}
              </h2>
              <p className="text-lg text-center max-w-[70vw] mx-auto">
                {slide.text}
              </p>
              <div className="flex min-w-[300px]">
                <Link to="/onlinecourses" className="w-full">
                  <PrimaryButton text={t("getStarted")} />
                </Link>
              </div>
            </div>
          )}
        </SwiperSlide>
      ))}

      <div className="swiper-pagination" />
    </Swiper>
  );
};

export default SlidesContent;
